import { render, staticRenderFns } from "./OrgTree.vue?vue&type=template&id=4b3ef833&scoped=true"
import script from "./OrgTree.vue?vue&type=script&lang=js"
export * from "./OrgTree.vue?vue&type=script&lang=js"
import style0 from "./OrgTree.vue?vue&type=style&index=0&id=4b3ef833&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ef833",
  null
  
)

export default component.exports